import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { CockpitUserType } from '../../api/types'

import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitPartnerIdsForSelectedRtm } from './selectCockpitPartnerIdsForSelectedRtm'
import { selectCockpitPendingActionsUsers } from './selectCockpitPendingActionsUsers'

export const selectCockpitManagerUsers = createSelector(
  [selectCockpitPendingActionsUsers, selectCockpitOffering, selectCockpitPartnerIdsForSelectedRtm],
  (users, selectedOffering, partnerIds) =>
    users.filter(
      (user) =>
        user.UserType === CockpitUserType.Manager &&
        partnerIds.has(user.PartnerId) &&
        (selectedOffering === ProgramTypes.Overall ||
          selectedOffering === ProgramTypes.Consolidated ||
          user.Offering === selectedOffering)
    )
)
